import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Product1 from '../Img/Product1.png'
import Product2 from '../Img/Product2.png'
import Product3 from '../Img/Product3.png'
import Product4 from '../Img/Product4.png'
import Product5 from '../Img/Product5.png'
import Product6 from '../Img/Product6.png'
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import decryptCookieData from "./Functions/decryptCookieData";

export const safeParseJson = (value, fallback = []) => {
    try {
        let parsed = typeof value === "string" ? JSON.parse(value) : value;
        if (typeof parsed === "string") parsed = JSON.parse(parsed); // handle double‑encoded
        return parsed || fallback;
    } catch {
        return fallback;
    }
};




const getDeliveryDate = (days) => {
    const date = new Date();
    date.setDate(date.getDate() + Number(days));
    return date.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }); // Example: "18 May 2025"
};

const ProductSinglePage = ({ setCartItemLength, fetchCart, cartButtons }) => {
    // const images = [Product1, Product2, Product3, Product4];
    const [images, setImages] = useState([])
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFading, setIsFading] = useState(false);
    const startX = useRef(0);
    const isDragging = useRef(false);
    const [openSection, setOpenSection] = useState(null);
    const { id, name } = useParams();
    const [singleProduct, setProducts] = useState({})
    const [selectedVariation, setSelectedVariation] = useState(null);
    const [selectedVariations, setSelectedVariations] = useState({});
    const url = process.env.REACT_APP_API_URL
    const [pincode, setPincodes] = useState([]);
    const [enteredPincode, setEnteredPincode] = useState("");
    const [deliveryStatus, setDeliveryStatus] = useState(""); // success/failure message
    const [isDeliveryAvailable, setIsDeliveryAvailable] = useState(null);
    const [groupedModal, setShowGroupedModal] = useState(false)
    const [showCheckoutModal, setShowCheckoutModal] = useState(false);
    const [checkoutForm, setCheckoutForm] = useState({
        name: "",
        mobile: "",
        email: "",
        description: "",
        cart_products: [],
        user_id: "",
        user_name: "",
        main_id: process.env.REACT_APP_PERFUME_ID
    });
    const navigate = useNavigate()

    let decodedName = "";
    let decodedId = "";
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    try {
        decodedName = decodeURIComponent(atob(name));
        decodedId = decodeURIComponent(atob(id));
    } catch (e) {
        console.error("Invalid encoded params:", e.message);
        // Optional: redirect to 404 or show error state
    }


    const addToCart = async () => {
        // const userData = decryptCookieData('2xgxgshdugyywerw12gh');
        const isLoggedIn = !!userData?.user_id;
        console.log(isLoggedIn)
        const variation = selectedVariation || singleProduct;
        const baseProduct = singleProduct;

        const item = {
            product_id: variation.product_id || baseProduct?.product_id,
            product_sku: variation.sku || baseProduct?.sku,
            product_name: baseProduct?.title || variation.title,
            product_price: variation.price || baseProduct?.originalPrice,
            product_saleprice: variation.salePrice || baseProduct?.discountPrice,
            product_stockstatus: variation.stock || baseProduct?.stock,
            product_status: baseProduct?.status || 'Active',
            product_image: variation.imageUrl || baseProduct?.image,
            product_gallery: baseProduct?.gallery || [],
            description: baseProduct?.description || "",
            short_description: baseProduct?.short_description || "",
            category: baseProduct?.category || "",
            product_type: baseProduct.product_type,
            variation_attributes: variation.attributes || {},
            typeofsimple: '',
            user_id: userData?.user_id || null,
            user_name: userData?.name || null,
            delivery_days: baseProduct.delivery_days || "",
            main_id: process.env.REACT_APP_PERFUME_ID,
        };

        try {
            if (isLoggedIn) {
                const response = await fetch(`${url}/cart`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(item),
                });
                const result = await response.json();

                if (!response.ok || result.isError) {

                    toast.warn(result.msg || "Product already in cart");
                } else {
                    await fetchCart(userData?.user_id)
                    toast.success("Product added to cart");
                }
            } else {
                const existing = JSON.parse(localStorage.getItem('guest_cart')) || [];
                const alreadyExists = existing.some(p => p.sku === item.product_sku);
                if (alreadyExists) {
                    toast.warn("Product already in cart");
                    return;
                }

                const updatedCart = [...existing, item];
                localStorage.setItem('guest_cart', JSON.stringify(updatedCart));
                setCartItemLength(updatedCart.length);
                toast.success("Product added to cart");
            }
        } catch (err) {
            console.error("Cart error:", err);
            toast.error("Something went wrong");
        }
    };


    console.log(name, id)

    const fetchPincodeData = async () => {
        try {
            const response = await fetch(`${url}/pincode/getall/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            console.log(res.pincodesData);
            setPincodes(res.pincodesData);
        } catch (error) {
            console.log(error);
        }
    }


    const handlePincodeCheck = () => {
        if (!enteredPincode || enteredPincode.length < 5) {
            setDeliveryStatus("Please enter a valid pincode");
            setIsDeliveryAvailable(null);
            return;
        }

        const isAvailable = pincode.some(p => p.pincode === enteredPincode);
        if (isAvailable) {
            setDeliveryStatus(`Delivery available to ${enteredPincode}`);
            setIsDeliveryAvailable(true);
        } else {
            setDeliveryStatus(`Sorry, delivery is not available to ${enteredPincode}`);
            setIsDeliveryAvailable(false);
        }
    };

    const handleVariationSelect = (slug, termName) => {
        const updatedSelections = {
            ...selectedVariations,
            [slug]: termName
        };
        setSelectedVariations(updatedSelections);

        const matched = matchVariation(updatedSelections, singleProduct.variation || []);
        if (matched) {
            setSelectedVariation(matched);
            setImages(matched.galleryImages?.map(url => ({ url })) || []);
        }
    };


    const matchVariation = (selected, variations) => {
        return variations.find((variation) => {
            return Object.entries(selected).every(([slug, name]) =>
                Object.values(variation.attributes).includes(name)
            );
        });
    };


    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    const handleThumbnailClick = (index) => {
        setIsFading(true);
        setTimeout(() => {
            setCurrentIndex(index);
            setIsFading(false);
        }, 300);
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const handleDragStart = (e) => {
        startX.current = e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
        isDragging.current = true;
    };

    const handleDragMove = (e) => {
        if (!isDragging.current) return;

        const moveX = e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
        const diff = moveX - startX.current;

        if (diff > 50) {
            handlePrev();
            isDragging.current = false;
        } else if (diff < -50) {
            handleNext();
            isDragging.current = false;
        }
    };

    const handleDragEnd = () => {
        isDragging.current = false;
    };

    const singleProductdata = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/single/${decodedId}`);
            const res = await response.json();

            const safeParse = (value, fallback = []) => {
                try {
                    return typeof value === "string" ? JSON.parse(value) : value || fallback;
                } catch (e) {
                    return fallback;
                }
            };

            const parsed = {
                ...res,
                gallery: safeParse(res.gallery),
                specifications: safeParse(res.specifications),
                key_features: safeParse(res.key_features),
                variation: safeParse(res.variation),
                attribute: safeParse(res.attribute)
            };

            setProducts(parsed);
            console.log(parsed)
            const allImages = [];
            if (parsed.image) {
                allImages.push({ url: parsed.image });
            }
            if (Array.isArray(parsed.gallery)) {
                allImages.push(...parsed.gallery);
            }
            setImages(allImages);
        } catch (error) {
            console.error("Error fetching product:", error);
        }
    };


    useEffect(() => {
        singleProductdata();
        fetchPincodeData();
    }, [])

    useEffect(() => {
        if (singleProduct.product_type === "Variable Product" && singleProduct.variation?.length > 0) {
            const firstVariation = singleProduct.variation[0];
            setSelectedVariation(firstVariation);
            setImages(firstVariation.galleryImages?.map(url => ({ url })) || []);

            // Auto-select the matching attribute terms from the first variation
            const firstVariationSelections = {};
            Object.entries(firstVariation.attributes || {}).forEach(([key, value]) => {
                // Find the attribute slug based on attribute name (since variation keys are names)
                const matchingAttr = singleProduct.attribute?.find(attr => attr.name === key);
                if (matchingAttr) {
                    firstVariationSelections[matchingAttr.slug] = value;
                }
            });
            setSelectedVariations(firstVariationSelections);
        }
    }, [singleProduct]);


    const handleVariationChange = (variation) => {
        setSelectedVariation(variation);
        setImages(variation.galleryImages?.map(url => ({ url: url })) || []);
    };

    const getDefaultCartButtons = () => {
        const getQuote = cartButtons.find(b => b.button_id === 'getquote' && b.default);
        const addToCart = cartButtons.find(b => b.button_id === 'addtocart' && b.default);
        const buyNow = cartButtons.find(b => b.button_id === 'buynow' && b.default);

        if (getQuote) return ['getquote']; // If Get Quote is default, it overrides the rest

        const result = [];
        if (addToCart) result.push('addtocart');
        if (buyNow) result.push('buynow');
        return result;
    };

    const handleBuyNow = () => {
        const variation = selectedVariation || singleProduct;
        const baseProduct = singleProduct;

        const item = {
            product_id: variation.product_id || baseProduct?.product_id,
            product_sku: variation.sku || baseProduct?.sku,
            product_name: baseProduct?.title || variation.title,
            product_price: variation.price || baseProduct?.originalPrice,
            product_saleprice: variation.salePrice || baseProduct?.discountPrice,
            product_stockstatus: variation.stock || baseProduct?.stock,
            product_status: baseProduct?.status || 'Active',
            product_image: variation.imageUrl || baseProduct?.image,
            product_gallery: baseProduct?.gallery || [],
            description: baseProduct?.description || "",
            short_description: baseProduct?.short_description || "",
            category: baseProduct?.category || "",
            product_type: baseProduct.product_type,
            variation_attributes: variation.attributes || {},
            typeofsimple: '',
            user_id: userData?.user_id || null,
            user_name: userData?.name || null,
            delivery_days: baseProduct.delivery_days || "",
            main_id: process.env.REACT_APP_PERFUME_ID,
        };

        const products = [item]
        let discount = 0
        const totalSalePrice = products.reduce((acc, p) => acc + Number(p.product_saleprice), 0);
        const totalBeforeDiscount = products.reduce((acc, p) => acc + Number(p.product_price), 0);
        const totalAfterDiscount = (totalSalePrice - discount).toFixed(2);

        const checkoutDetails = {
            products,

            totalBeforeDiscount: totalBeforeDiscount,
            totalAfterDiscount,
        };

        localStorage.setItem("checkout_data", JSON.stringify(checkoutDetails));
        navigate("/checkout")
    }
    // const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
    // const isLoggedIn = !!userData?.user_id;
    console.log(
        {
            name: checkoutForm.name,
            mobile: checkoutForm.mobile,
            email: checkoutForm.email,
            description: checkoutForm.description,
            cart_products: [singleProduct],
            user_id: userData?.user_id,
            user_name: userData?.full_name,
            main_id: process.env.REACT_APP_PERFUME_ID
        }
    )
    const handleAskQuote = async () => {
        const userData = decryptCookieData('2xgxgshdugyywerw12gh');
        const isLoggedIn = !!userData?.user_id;
        const variation = selectedVariation || singleProduct;
        const baseProduct = singleProduct;

        const item = {
            product_id: variation.product_id || baseProduct?.product_id,
            product_sku: variation.sku || baseProduct?.sku,
            product_name: baseProduct?.title || variation.title,
            product_price: variation.price || baseProduct?.originalPrice,
            product_saleprice: variation.salePrice || baseProduct?.discountPrice,
            product_stockstatus: variation.stock || baseProduct?.stock,
            product_status: baseProduct?.status || 'Active',
            product_image: variation.imageUrl || baseProduct?.image,
            product_gallery: baseProduct?.gallery || [],
            description: baseProduct?.description || "",
            short_description: baseProduct?.short_description || "",
            category: baseProduct?.category || "",
            product_type: baseProduct.product_type,
            variation_attributes: variation.attributes || {},
            typeofsimple: '',
            user_id: userData?.user_id || null,
            user_name: userData?.name || null,
            delivery_days: baseProduct.delivery_days || "",
            main_id: process.env.REACT_APP_PERFUME_ID,
        };
        const payload = {
            name: checkoutForm.name,
            mobile: checkoutForm.mobile,
            email: checkoutForm.email,
            description: checkoutForm.description,
            cart_products: [item],
            user_id: userData?.user_id,
            user_name: userData?.full_name || checkoutForm.name,
            main_id: process.env.REACT_APP_PERFUME_ID
        }
        try {
            const response = await fetch(`${url}/payment/getquote`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            })
            const res = await response.json();
            if (response.ok) {
                toast.success("Request sent. Our team will contact you shortly.")
                setShowCheckoutModal(false)
            }
        } catch (error) {
            console.log(error)
        }
    }
    const defaultButtons = getDefaultCartButtons();

    const groupedProducts = safeParseJson(singleProduct.grouped_product)
    console.log(groupedProducts)
    return (
        <>
            <ToastContainer position="top-center" autoClose={3000} />
            <div className="psp-perfume">
                <div className="psp-main-thumb">
                    <div className="psp-image-perfume">
                        <button className="psp-controls chevron-left" onClick={handlePrev}>
                            <i className="fa fa-chevron-left"></i>
                        </button>

                        <div className="psp-slider-container">
                            <AnimatePresence mode="wait">
                                <motion.img
                                    key={currentIndex}
                                    src={`${url}${images[currentIndex]?.url}`}
                                    alt="Product"
                                    className="main-image"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.4, ease: "easeInOut" }}
                                    drag="x"
                                    dragConstraints={{ left: 0, right: 0 }}
                                    onDragEnd={(event, info) => {
                                        if (info.offset.x > 50) handlePrev();
                                        if (info.offset.x < -50) handleNext();
                                    }}
                                />
                            </AnimatePresence>
                        </div>

                        <button className="psp-controls chevron-right" onClick={handleNext}>
                            <i className="fa fa-chevron-right"></i>
                        </button>
                    </div>

                    {/* Thumbnail Images */}
                    <div className="psp-thumbnails">
                        {images.map((image, index) => (
                            <motion.img
                                key={index}
                                src={`${url}${image.url}`}
                                alt={`Thumbnail ${index + 1}`}
                                className={`thumbnail ${currentIndex === index ? "active" : ""}`}
                                onClick={() => setCurrentIndex(index)}
                                whileHover={{ scale: 1.1 }}
                                transition={{ duration: 0.3 }}
                            />
                        ))}
                    </div>
                </div>

                <div className="psp-content-perfume">
                    <h2 className="psp-product-title">{singleProduct.title}</h2>
                    {/* <p className="psp-discount-price">₹{singleProduct.discountPrice}</p>
                    <p className="psp-regular-price"><span className="psp-regular-line">MRP ₹{singleProduct.originalPrice}</span> <span className="psp-regular-discount">(Save ₹{singleProduct.originalPrice - singleProduct.discountPrice})</span></p> */}
                    {/* <p className="psp-product-short-description" dangerouslySetInnerHTML={{ __html: singleProduct.short_description }}></p> */}
                    {(selectedVariation?.salePrice > 0 || singleProduct?.discountPrice > 0) && (
                        <>
                            <p className="psp-discount-price">
                                ₹{selectedVariation ? selectedVariation.salePrice : singleProduct.discountPrice}
                            </p>

                            {(selectedVariation?.price > 0 || singleProduct?.originalPrice > 0) && (
                                <p className="psp-regular-price">
                                    <span className="psp-regular-line">
                                        MRP ₹{selectedVariation ? selectedVariation.price : singleProduct.originalPrice}
                                    </span>
                                    <span className="psp-regular-discount">
                                        (Save ₹
                                        {selectedVariation
                                            ? selectedVariation.price - selectedVariation.salePrice
                                            : singleProduct.originalPrice - singleProduct.discountPrice})
                                    </span>
                                </p>
                            )}
                        </>
                    )}



                    {/* <div
                        className="psp-product-short-description"
                        dangerouslySetInnerHTML={{ __html: singleProduct.short_description }}
                    ></div> */}
                    <div
                        className="psp-product-short-description"
                        dangerouslySetInnerHTML={{ __html: singleProduct.short_description }}
                    />

                    <div className="variation-circle-container">

                        {singleProduct.attribute?.map((attr) => {
                            const { slug, name, selectedTerms } = attr;

                            return (
                                <div key={attr.id} className="variation-section">
                                    <p>{name?.charAt(0).toUpperCase() + name?.slice(1)}</p>
                                    {slug === 'color' && (
                                        <div className="color-options">
                                            {selectedTerms.map(term => (
                                                <div
                                                    key={term.id}
                                                    className={`color-circle ${selectedVariations[slug] === term.name ? "selected" : ""}`}
                                                    style={{ backgroundColor: term.name.toLowerCase() }}
                                                    title={term.name}
                                                    onClick={() => handleVariationSelect(slug, term.name)}
                                                />
                                            ))}
                                        </div>
                                    )}
                                    {console.log(selectedTerms)}
                                    {slug === 'other' && (
                                        <div className="image-options">
                                            {selectedTerms.map(term => {
                                                const matchedVariation = singleProduct.variation?.find(variation =>
                                                    variation.attributes?.[name] === term.name
                                                );

                                                const imageUrl = matchedVariation?.imageUrl || matchedVariation?.galleryImages?.[0] || "";

                                                return (
                                                    <img
                                                        key={term.id}
                                                        src={`${url}${imageUrl}`}
                                                        alt={term.name}
                                                        className={`option-image-circle ${selectedVariations[slug] === term.name ? "selected" : ""}`}
                                                        onClick={() => handleVariationSelect(slug, term.name)}
                                                    />
                                                );
                                            })}
                                        </div>
                                    )}



                                    {!['color', 'other'].includes(slug) && (
                                        <div className="radio-options">
                                            {selectedTerms.map(term => {
                                                const isSelected = selectedVariations[slug] === term.name;
                                                return (
                                                    <label key={term.id} className={`radio-box ${isSelected ? "selected" : ""}`}>
                                                        <input
                                                            type="radio"
                                                            name={slug}
                                                            checked={isSelected}
                                                            onChange={() => handleVariationSelect(slug, term.name)}
                                                        />
                                                        {term.name}
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    )}

                                </div>
                            );
                        })}



                    </div>
                    {
                        (singleProduct.product_type === "Grouped Product") && (
                            <p className="hbtviewproduct-modaltext" onClick={() => setShowGroupedModal(true)}>View Product</p>
                        )
                    }

                    {/* Grouped Products Section */}
                    {(singleProduct.product_type === "Grouped Product" && groupedModal) && (
                        <GroupedProductsModal products={groupedProducts} onAddToCart={addToCart} onClose={() => setShowGroupedModal(false)}

                        />
                    )}
                    {defaultButtons.includes('getquote') ? (
                        <div className="psp-add-to-cart"
                            onClick={() => setShowCheckoutModal(true)}
                        >
                            <button className="psp-add-to-cart-btn">Get Quote</button>
                        </div>
                    ) : (
                        <div className="psp-cart-buttons-wrapper">
                            {defaultButtons.includes('addtocart') && (
                                <div className="psp-add-to-cart" onClick={addToCart}>
                                    <button className="psp-add-to-cart-btn">Add to Cart</button>
                                </div>
                            )}

                            {/* {defaultButtons.includes('addtocart') && defaultButtons.includes('buynow') && (
                                <span className="psp-or-text">or</span>
                            )} */}

                            {defaultButtons.includes('buynow') && (
                                <div className="psp-add-to-cart"
                                    onClick={handleBuyNow}
                                >
                                    <button className="psp-add-to-cart-btn">Buy Now</button>
                                </div>
                            )}
                        </div>
                    )}

                    {/* {defaultButtons.includes('addtocart') && (
                        <div className="psp-add-to-cart" onClick={addToCart}>
                            <button className="psp-add-to-cart-btn">Add to Cart</button>
                        </div>
                    )}

                    {defaultButtons.includes('buynow') && (
                        <div className="psp-add-to-cart" 
                        // onClick={buyNow}
                        >
                            <button className="psp-add-to-cart-btn">Buy Now</button>
                        </div>
                    )}

                    {defaultButtons.includes('getquote') && (
                        <div className="psp-add-to-cart" 
                        // onClick={() => setShowQuoteModal(true)}
                        >
                            <button className="psp-add-to-cart-btn">Get Quote</button>
                        </div>
                    )} */}


                    {/* <div className="psp-add-to-cart" onClick={addToCart}>
                        <button className="psp-add-to-cart-btn">Add to Cart</button>
                    </div> */}
                    <div className="psp-estimated-date">
                        <div className="psp-estimated-input">
                            <input type="number" placeholder="Enter your pincode"
                                value={enteredPincode}
                                onChange={(e) => setEnteredPincode(e.target.value)}
                            /><button onClick={handlePincodeCheck} className="psp-estimated-btn">Check</button>
                        </div>
                        <p
                            className="psp-estimated-time"
                            style={{
                                marginTop: '10px',
                                fontWeight: 'bold',
                                color: deliveryStatus.includes("not available") ? "red" : "green"
                            }}
                        >
                            {deliveryStatus}
                        </p>
                        {console.log(deliveryStatus)}
                        {/* <p className="psp-estimated-time">Estimated delivery by <strong>{getDeliveryDate(singleProduct.delivery_days)}</strong> </p> */}
                        {isDeliveryAvailable && (
                            <p className="psp-estimated-time">
                                Estimated delivery by <strong>{getDeliveryDate(singleProduct.delivery_days)}</strong>
                            </p>
                        )}


                    </div>
                </div>
            </div>
            <div className="psp-details">
                {/* Description Section */}
                <div className="psp-section">
                    <div className="psp-section-header" onClick={() => toggleSection("description")}>
                        <h3>Description</h3>
                        <i className={`fa ${openSection === "description" ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                    </div>
                    {openSection === "description" && (
                        // <div className="psp-section-content">
                        //     <p>
                        //         Indulge in the captivating aroma of our premium perfume collection.
                        //         Crafted with exquisite ingredients, each fragrance is designed to leave a lasting impression.
                        //     </p>
                        //     <ul>
                        //         <li>Long-lasting and elegant fragrance</li>
                        //         <li>Infused with high-quality essential oils</li>
                        //         <li>Perfect for daily wear and special occasions</li>
                        //         <li>Luxurious packaging for a premium feel</li>
                        //     </ul>
                        // </div>
                        <div
                            className="psp-section-content"
                            dangerouslySetInnerHTML={{ __html: singleProduct.description }}
                        />

                    )}
                </div>

                {/* Specifications Section */}
                {/* Specifications Section */}
                {Array.isArray(singleProduct?.specifications) && singleProduct.specifications.length > 0 && (
                    <div className="psp-section">
                        <div
                            className="psp-section-header"
                            onClick={() => toggleSection("specifications")}
                        >
                            <h3>Specifications</h3>
                            <i
                                className={`fa ${openSection === "specifications" ? "fa-chevron-up" : "fa-chevron-down"}`}
                            ></i>
                        </div>
                        {openSection === "specifications" && (
                            <div className="psp-section-content">
                                <ul>
                                    {singleProduct.specifications.map((spec, index) => (
                                        <li key={index}>
                                            <strong>{spec.label}:</strong> {spec.value}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}

                {/* Key Features Section */}
                {Array.isArray(singleProduct?.key_features) && singleProduct.key_features.length > 0 && (
                    <div className="psp-section">
                        <div
                            className="psp-section-header"
                            onClick={() => toggleSection("features")}
                        >
                            <h3>Key Features</h3>
                            <i
                                className={`fa ${openSection === "features" ? "fa-chevron-up" : "fa-chevron-down"}`}
                            ></i>
                        </div>
                        {openSection === "features" && (
                            <div className="psp-section-content">
                                <ul>
                                    {singleProduct.key_features.map((feature, index) => (
                                        <li key={index}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}


                {/* FAQs Section */}
                {/* <div className="psp-section">
                    <div className="psp-section-header" onClick={() => toggleSection("faq")}>
                        <h3>FAQs</h3>
                        <i className={`fa ${openSection === "faq" ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                    </div>
                    {openSection === "faq" && (
                        <div className="psp-section-content">
                            <p><strong>Q:</strong> How long does the fragrance last?</p>
                            <p><strong>A:</strong> The perfume lasts for 8-12 hours, depending on skin type and environment.</p>

                            <p><strong>Q:</strong> Is it suitable for sensitive skin?</p>
                            <p><strong>A:</strong> Yes, our alcohol-free formula is gentle on sensitive skin.</p>

                            <p><strong>Q:</strong> Can I gift this perfume?</p>
                            <p><strong>A:</strong> Absolutely! It comes in luxurious packaging, making it an ideal gift.</p>
                        </div>
                    )}
                </div> */}

            </div>
            {console.log(showCheckoutModal)}
            {showCheckoutModal && (
                <div className="checkout-modal-overlay">
                    <div className="checkout-modal-content">
                        <div className="group-modal-header">
                            <h3>Enter Guest Details</h3>
                            <span className="checkout-close" onClick={() => setShowCheckoutModal(false)}>
                                <i className="fa-solid fa-xmark"></i>
                            </span>
                        </div>
                        <form className="checkout-form">
                            <div className="checkout-form-group">
                                <label htmlFor="name">Full Name</label>
                                <input
                                    id="name"
                                    type="text"
                                    placeholder="Full Name"
                                    value={checkoutForm.name}
                                    onChange={(e) => setCheckoutForm(prev => ({ ...prev, name: e.target.value }))}
                                />
                            </div>

                            <div className="checkout-form-group">
                                <label htmlFor="mobile">Phone Number</label>
                                <input
                                    id="mobile"
                                    type="tel"
                                    placeholder="Phone Number"
                                    value={checkoutForm.phone}
                                    onChange={(e) => setCheckoutForm(prev => ({ ...prev, mobile: e.target.value }))}
                                />
                            </div>

                            <div className="checkout-form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                    id="email"
                                    type="email"
                                    placeholder="Email Address"
                                    value={checkoutForm.email}
                                    onChange={(e) => setCheckoutForm(prev => ({ ...prev, email: e.target.value }))}
                                />
                            </div>

                            <div className="checkout-form-group">
                                <label htmlFor="description">Description</label>
                                <input
                                    id="description"
                                    type="text"
                                    placeholder="Description"
                                    value={checkoutForm.description}
                                    onChange={(e) => setCheckoutForm(prev => ({ ...prev, description: e.target.value }))}
                                />
                            </div>

                            <button
                                type="button"
                                className="checkout-submit-btn"
                                // onClick={() => {
                                //     const checkoutDetails = {
                                //         ...checkoutForm,
                                //         products,
                                //         coupon: couponCode || null,
                                //         discountAmount: discount,
                                //         totalBeforeDiscount: products.reduce((acc, p) => acc + Number(p.product_price), 0),
                                //         totalAfterDiscount: (products.reduce((acc, p) => acc + Number(p.product_saleprice), 0) - discount).toFixed(2),
                                //         isCouponApplied: !!discount
                                //     };
                                //     localStorage.setItem("checkout_data", JSON.stringify(checkoutDetails));
                                //     setShowCheckoutModal(false);
                                //     if (userData) {
                                //         navigate("/checkout");
                                //     } else {
                                //         navigate("/login");
                                //         sessionStorage.setItem("navigatepage", "/checkout");
                                //     }
                                // }}
                                onClick={handleAskQuote}
                            >
                                Ask Quote
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default ProductSinglePage;

function GroupedProductsModal({ products = [], title = "Products", onAddToCart, onClose }) {
    if (!Array.isArray(products) || products.length === 0) return null;

    const normalized = products.map((p) => ({
        id: p.product_id || p.id,
        title: p.title || 'Untitled',
        image: p.imageUrl || p.image || '/default-image.jpg',
        discountPrice: p.salePrice || p.discountPrice,
        originalPrice: p.price || p.originalPrice,
        inStock: (p.stock ?? p.totalStock ?? 0) > 0,
    }));

    return (
        <div className="modal-overlayhbt">
            <div className="modal-boxhbt">
                <div className="modal-headerhbt">
                    <h2>{title}</h2>
                    <button className="close-btnhbt" onClick={onClose}>&times;</button>
                </div>

                {/* <h3 className="section-titlehbt">Starters</h3> */}

                <div className="modal-listhbt">
                    {normalized.map((p, idx) => (
                        <motion.div
                            key={p.id || idx}
                            className="modal-itemhbt"
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: idx * 0.05 }}
                        >
                            <div className="indicatorhbt" style={{ backgroundColor: p.inStock ? '#3152f4' : '#3152f4' }}></div>
                            <div className="item-titlehbt">{p.title}</div>
                            <img
                                src={p.image.startsWith("http") ? p.image : `${process.env.REACT_APP_API_URL}${p.image}`}
                                alt={p.title}
                                className="item-imagehbt"
                            />
                        </motion.div>
                    ))}
                </div>
                <button className="primary-btnhbt" onClick={() => onAddToCart(products)}>Add to Cart</button>

            </div>
        </div>
    );
}
